import i18n, { InitOptions } from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import Backend from 'i18next-http-backend';
import { initReactI18next } from 'react-i18next';
import { Language } from './types/common';
import ruTranslationUrl from './locales/ru/translation.json';
import faTranslationUrl from './locales/fa/translation.json';
import enTranslationUrl from './locales/en_US/translation.json';

const hashedLocales = {
  ru: { translation: ruTranslationUrl },
  fa: { translation: faTranslationUrl },
  en_US: { translation: enTranslationUrl },
};

const getConfiguration = (): InitOptions => {
  let language = 'en_US';
  if (navigator.language) {
    if (navigator.language.includes('ru')) {
      language = Language.RU;
    } else if (navigator.language.includes('fa')) {
      language = Language.FA;
    }
  }
  return {
    compatibilityJSON: 'v3',
    fallbackLng: language,
    detection: {
      order: ['localStorage'],
      caches: ['localStorage'],
    },
    backend: {
      loadPath: (lngs: string | string[], namespaces: string | string[]) => {
        const lng = Array.isArray(lngs) ? lngs[0] : lngs;
        const ns = Array.isArray(namespaces) ? namespaces[0] : namespaces;

        const locale = hashedLocales[lng as keyof typeof hashedLocales];
        if (locale && ns in locale) {
          return locale[ns as keyof typeof locale];
        }
        return `/locales/${lng}/${ns}.json`;
      },
    },
    interpolation: {
      escapeValue: false,
    },
  };
};

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init(getConfiguration());

export default i18n;
